import React from 'react'
import { slice, isEmpty } from 'ramda'

import {
  Spacing,
  Box,
  Text,
  Button,
  ContainerSpinner
} from '../../../../components/ui'
import { StudyCardMini } from '../'
import { RenderFromQuery } from '../../../../components/util'

import { StudiesQuery, StudiesQueryVariables } from '../../../../state/queries'

export const ResultsListMini = ({ limit }) => (
  <Box size="xl" backgroundColor="white">
    <Spacing size="xl">
      <Spacing direction="row" justify="space-between" align="center">
        <Text h2>Results</Text>
        <Button transparent link themeColor="greyL1" to="/results">
          See all >
        </Button>
      </Spacing>
      <RenderFromQuery
        query={StudiesQuery}
        variables={StudiesQueryVariables.completed}
        renderLoading={() => <ContainerSpinner />}
        renderData={({ allOpportunities }) => {
          const trimmedStudies = slice(0, limit, allOpportunities.edges)

          if (isEmpty(trimmedStudies))
            return (
              <Text t2>
                Once your study is completed, the results will appear here.
              </Text>
            )

          return (
            <Spacing size="l">
              {trimmedStudies.map(({ node }) => (
                <StudyCardMini key={node.id} opportunity={node} />
              ))}
            </Spacing>
          )
        }}
      />
    </Spacing>
  </Box>
)
